import type { StepTypeKebabCase } from 'src/types/course/step';

function componentNameParts(component: string) {
  if (!component) return [];
  const componentStrapiName = component.includes('.')
    ? component.split('.')?.[1]
    : component;
  return componentStrapiName ? componentStrapiName.split('-') : [];
}
export function componentNameSnakeCase(component: string) {
  return componentNameParts(component)
    .map((c) => c?.toLowerCase())
    .join('_');
}

export function componentNameSnakeCaseUpper(component: string) {
  return componentNameParts(component)
    .map((c) => c?.toUpperCase())
    .join('_');
}

export function componentNameCamelCase(component: string) {
  return componentNameParts(component)
    .map((c) => (c.length > 0 ? c[0]?.toUpperCase() + c.slice(1) : ''))
    .join('');
}

export function componentNameSentenceCase(component: string) {
  return componentNameParts(component)
    .map((c) => (c.length > 0 ? c[0]?.toUpperCase() + c.slice(1) : ''))
    .join(' ');
}

export function componentNameKebabCase(component: string) {
  return componentNameParts(component)
    .map((c) => c?.toLowerCase())
    .join('-') as StepTypeKebabCase;
}
